import { getMerchantGroupData, getPermission } from '@/service/user/user'

export default {
  namespaced: true,
  state: {
    data: {},
  },
  getters: {
    user: state => state,
  },
  mutations: {
    SET_USER(state, payload) {
      state.data = payload
    },
  },
  actions: {
    async fetch({ commit }) {
      const veripagId = sessionStorage.getItem('veripagID')
      if (veripagId) {
        const { data, status } = await getMerchantGroupData(veripagId)

        if (status === 200) {
          const permissionData = await getPermission(data.id)
          commit('SET_USER', { ...data, permissions: permissionData.data.permissions })
        }

        if (status === 403) {
          sessionStorage.removeItem('token')
          window.location.href = '/'
        }
      }
    },
  },
}
